<template>

  <div style="display: flex;flex-direction: column;justify-content: start">

    <div class="tabsCell" v-for="(item,index) in tabs" :key="index"
         :class="{
           activeClass:activeTab==index?true:false,
           nomalClass:activeTab==index?false:true}"
         :style="{backgroundColor:activeTab==index?backgroundColor_active:backgroundColor_normal}"
         @click="clicked(index,item)">
      <span class="iconfont" :class="classObject(item)" style="font-size: 40px; height: 80px;line-height: 80px;background-color: transparent"></span>
      <span style="height: 30px; font-size: 14px">{{item.title}}</span>
    </div>



  </div>

</template>

<script>
  export default {
    name: "IHVerticalTabs",
    data(){
      return {
        mmm:"&#xe663;",
        activeTab:1,
        backgroundColor_active:"rgb(103,128,158)",
        backgroundColor_normal:"white",

        tabs:[
          {
            mCode:"landcover",
            title:"Global Land Cover",
            icon:"icon-quanqiu"
          },
          {
            mCode:"soil",
            title:"Global Soil",
            icon:"icon-turang"
          },
          {
            mCode:"climate",
            title:"Global Climate Zones",
            icon:"icon-qihoubianhua"
          },
          {
            mCode:"river",
            title:"Global River System",
            icon:"icon-jurassic_heliuxiangdai"
          },
          {
            mCode:"terrain",
            title:"Global Terrain Slope",
            icon:"icon-quanqiuhuadaiquan"
          },
          {
            mCode:"digitalElevationModels",
            title:"Global Digital Elevation Models",
            icon:"icon-guojiaguanliicon-"
          },
          {
            mCode:"politicalMaps",
            title:"Global Political Maps",
            icon:"icon-huaban-"
          }
        ]

      };
    },
    mounted() {

    },
    methods:{

      clicked:function (index,item) {
        this.activeTab = index;
        this.$emit("tabChanged",item.mCode);
      },

      classObject: function (item) {
        let codeKey = item.icon;
        let obj = {};
        obj[codeKey] = true;
        return obj;
      }
    },
    computed:{

    }
  }
</script>

<style scoped lang="scss">


  .activeClass
  {
    border-right: 4px solid deepskyblue;
    color: white;
    font-weight: bold;
  }

  .nomalClass
  {
    color: black;
    border-right: none;
    font-weight: normal;

  }
  .tabsCell
  {
    width: 99%;
    height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: end;
    background-color: white
  }

</style>



// WEBPACK FOOTER //
// src/components/widgets/IHVerticalTabs.vue